import { render, staticRenderFns } from "./DescuentosTemporales.vue?vue&type=template&id=463c8025"
import script from "./DescuentosTemporales.vue?vue&type=script&lang=js"
export * from "./DescuentosTemporales.vue?vue&type=script&lang=js"
import style0 from "./DescuentosTemporales.vue?vue&type=style&index=0&id=463c8025&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VIcon,VTextField})
